import { hash } from "sjcl";
import Cookies from "js-cookie";
import emailValidator from "validator/es/lib/isEmail";
import alphaValidator from "validator/es/lib/isAlpha";

export function isEmail(value) {
  const isValid = emailValidator(value);
  const error = isValid
    ? false
    : value
    ? "Enter a valid email address"
    : "Please enter your Latitude ID (the email address you used to sign up to the app)";
  return {
    isValid,
    error,
  };
}

export function isAlpha(value, errorMessages = {}) {
  const isValid = alphaValidator(value);
  const error = isValid
    ? false
    : value
    ? errorMessages.invalid
    : errorMessages.empty;
  return {
    isValid,
    error,
  };
}

export function isVerificationCode(code, numDigits = 6) {
  return new RegExp(`^\\d{${numDigits}}$`).test(code);
}

export const PASSWORD_EVALUATOR = [
  {
    label: "8 characters",
    success: (value) => value.length >= 8,
  },
  {
    label: "1 upper + lower case",
    success: (value) => /[A-Z]/.test(value) && /[a-z]/.test(value),
  },
  {
    label: "1 number",
    success: (value) => /\d/.test(value),
  },
  {
    label: "1 symbol",
    // TODO: remove useless escapes
    // eslint-disable-next-line no-useless-escape
    success: (value) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value),
  },
];

export const getTnCString = (profileId) => {
  const tncVersion = hash.sha256.hash(process.env.REACT_APP_TNC_VERSION);
  const idHash = hash.sha256.hash(profileId);
  return JSON.stringify([tncVersion, idHash]);
};

export const validateTnCString = (profileId) =>
  profileId ? Cookies.get("TnC") === getTnCString(profileId) : false;

export const setTnCString = (profileId) => {
  if (profileId) {
    Cookies.set("TnC", getTnCString(profileId));
  }
};
